import {combineReducers} from 'redux';

const languages = (state = [], action) => {
  switch (action.type) {
    case 'SET_LANGUAGES':
      return action.languages.reduce(
        (nextState, language) => ({
          ...nextState,
          [language.id]: language,
        }),
        state
      );
    case 'REMOVE_LANGUAGES':
      return action.ids.reduce((nextState, id) => {
        // eslint-disable-next-line no-unused-vars
        const {[id]: remove, ...nextLanguages} = nextState;
        return nextLanguages;
      }, state);
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case 'SET_LANGUAGES_LOADING':
      return true;
    case 'SET_LANGUAGES':
    case 'SET_LANGUAGES_ERROR':
      return false;
    default:
      return state;
  }
};

const loaded = (state = false, action) => {
  switch (action.type) {
    case 'SET_LANGUAGES':
      return Date.now();
    default:
      return state;
  }
};

const error = (state = false, action) => {
  switch (action.type) {
    case 'SET_LANGUAGES_ERROR':
      return action.message;
    case 'SET_LANGUAGES_LOADING':
    case 'SET_LANGUAGES':
      return false;
    default:
      return state;
  }
};

export default combineReducers({languages, loading, loaded, error});
